/** xr-standard reserves the first two axes for a touchpad. */
export function readStick(axes: readonly number[]) {
  const start = axes.length >= 4 ? 2 : 0
  const deadzone = (value = 0) => Number.isFinite(value) && Math.abs(value) >= 0.22 ? value : 0
  return { x: deadzone(axes[start]), y: deadzone(axes[start + 1]) }
}

export function snapTurn(axis: number, armed: boolean) {
  if (Math.abs(axis) < 0.25) return { delta: 0, armed: true }
  if (armed && Math.abs(axis) > 0.7) return { delta: -Math.sign(axis) * Math.PI / 4, armed: false }
  return { delta: 0, armed }
}

export function gazeAngles(direction: { x: number; y: number; z: number }) {
  return { yaw: Math.atan2(-direction.x, -direction.z) || 0, pitch: Math.asin(Math.max(-1, Math.min(1, direction.y))) }
}

export function rotateTrackedPosition(position: { x: number; y: number; z: number }, yaw: number) {
  const cosine = Math.cos(yaw)
  const sine = Math.sin(yaw)
  return { x: position.x * cosine + position.z * sine, y: position.y, z: position.z * cosine - position.x * sine }
}

export const inventoryGrid = { x: 44, y: 152, width: 104, height: 82, columns: 9 }

export function inventorySlotAt(x: number, y: number, slots: number) {
  const grid = inventoryGrid
  if (x < grid.x || y < grid.y) return null
  const col = Math.floor((x - grid.x) / grid.width)
  const row = Math.floor((y - grid.y) / grid.height)
  const slot = row * grid.columns + col
  if (col >= grid.columns || slot >= slots || (x - grid.x) % grid.width >= grid.width - 6 || (y - grid.y) % grid.height >= grid.height - 6) return null
  return slot
}

/** Quest Touch Plus exposes xr-standard controls; profile names/source order can change. */
export function questControllers(sources: Iterable<XRInputSource>) {
  const controllers: { left?: XRInputSource; right?: XRInputSource } = {}
  for (const source of sources) {
    if (!source.hand && source.gamepad?.mapping === 'xr-standard' && (source.handedness === 'left' || source.handedness === 'right')) controllers[source.handedness] = source
  }
  return controllers
}

/** Controller targetRaySpace is reference-space relative, just like the headset pose. */
export function controllerRay(transform: { position: { x: number; y: number; z: number }; orientation: { x: number; y: number; z: number; w: number } }, head: { x: number; y: number; z: number }, yaw: number) {
  const q = transform.orientation
  const origin = rotateTrackedPosition({ x: transform.position.x - head.x, y: transform.position.y - head.y, z: transform.position.z - head.z }, yaw)
  const direction = rotateTrackedPosition({ x: -2 * (q.x * q.z + q.w * q.y), y: 2 * (q.w * q.x - q.y * q.z), z: 2 * (q.x * q.x + q.y * q.y) - 1 }, yaw)
  return { origin, direction }
}
